import React from 'react';
import { Accordion, Form, InputGroup } from 'react-bootstrap';
import {
  PreferencesTabs,
  type DashboardColumn,
  type PreferencesTabsType,
} from '../Preferences';
import { useDashboardColumns } from '../../../hooks';
import { ColumnIdToTitle } from '../../../hooks/types';

interface ListInformationSettingProps {
  activeTab: PreferencesTabsType;
  formState: Record<string, boolean>;
  onChangeInformation: (name: string, value: boolean) => void;
}
const ListInformationSetting = ({
  onChangeInformation,
  formState,
  activeTab,
}: ListInformationSettingProps) => {
  const { dashboardColumns } = useDashboardColumns();
  return (
    <Accordion.Item eventKey={PreferencesTabs.LIST_INFORMATION}>
      <Accordion.Header>
        List information
        {activeTab !== PreferencesTabs.LIST_INFORMATION ? (
          <i className="fa fa-plus" aria-hidden="true" />
        ) : (
          <i className="fa fa-minus" aria-hidden="true" />
        )}
      </Accordion.Header>
      <Accordion.Body>
        <div className="list-information-header my-4">
          Select the information you would like to see in your patient lists
          (max 7 options recommended)
        </div>
        <Form className="list-information-options width-60-percent">
          {dashboardColumns.map((dashboardColumn: DashboardColumn) => {
            return (
              <InputGroup className="mb-3" key={dashboardColumn.id}>
                <InputGroup.Checkbox
                  aria-label="Checkbox for following text input"
                  name={dashboardColumn.id}
                  checked={formState[dashboardColumn.id] ?? false}
                  onChange={(e) =>
                    onChangeInformation(e.target.name, e.target.checked)
                  }
                />
                {
                  ColumnIdToTitle[
                    dashboardColumn.id as keyof typeof ColumnIdToTitle
                  ]
                }
              </InputGroup>
            );
          })}
        </Form>
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default ListInformationSetting;
